<template>
  <div class="home container">
    <div class="d-flex justify-content-center p-0 px-">
      <section>
        <div class="breadcrumb-voucher py-3">
          <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
              <li class="breadcrumb-item">
                <router-link to="/">
                  <icon class="color--info" name="house"></icon>
                </router-link>
              </li>
              <li class="breadcrumb-item">
                <router-link class="color--primary active fw-semibold" to="/">
                  <span>Emissão de certificado</span>
                </router-link>
              </li>
            </ol>
          </nav>
        </div>

        <div class="row">
          <div class="col-12 col-lg d-flex justify-content-start mr-6">
            <div class="text-start">
              <div
                class="h-medium fw-400 pb-2 d-flex flex-column align-items-start"
              >
                <span class="fw-semibold h-x-medium">Emissão Online</span>
                <span class="mt-4">Emita ou Renove</span>
                <span>
                  seu <span class="fw-semibold">Certificado</span> de
                </span>
                <span class="w-auto">
                  forma <span class="fw-semibold">simples</span> e
                  <span class="fw-semibold">rápida</span>
                </span>
                <img
                  ref="easterEggImg"
                  class="mt-4"
                  :class="[
                    'easter-egg-img',
                    { 'easter-egg-animate': isAnimating },
                  ]"
                  src="@/assets/images/emissão-online.svg"
                  alt="icon-shield"
                  @click="handleEasterEggClick"
                />
              </div>
            </div>
          </div>
          <div
            class="col-12 col-lg-7 mt-4 mt-lg-2 d-flex flex-column justify-content-center align-items-start align-items-lg-center"
          >
            <div class="text-start text-lg-center mb-4">
              <span class="fs-5">
                Escolha abaixo como deseja
                <span class="fw-semibold">emitir</span> ou
                <span class="fw-semibold">renovar</span> seu Certificado
              </span>
            </div>
            <div
              class="options_wrapper d-flex flex-column flex-lg-row justify-content-center align-items-stretch gap-3 w-100"
            >
              <div class="option">
                <button
                  class="btn option_button d-flex flex-column justify-content-center align-items-center"
                  type="button"
                  aria-label="Emitir certificado usando Bird ID"
                  @click="handleBirdIdButtonClick"
                >
                  <img
                    class="option_image pt-1"
                    src="@/assets/images/birdID-horizontal.svg"
                    alt="icon-shield"
                  />
                  <p class="text-start text-lg-center option_text">
                    Tenho um <span class="fw-semibold">Bird ID</span> e desejo
                    utilizar!
                  </p>
                </button>
              </div>
              <div class="option">
                <button
                  class="btn option_button d-flex flex-column justify-content-center align-items-center"
                  type="button"
                  aria-label="Emitir certificado usando certificado A3 em nuvem"
                  @click="handleHubCloudButtonClick"
                >
                  <img
                    class="option_image"
                    src="@/assets/images/cloud-shield.svg"
                    alt="icon-shield"
                  />
                  <p class="text-start text-lg-center option_text">
                    Tenho um certificado
                    <span class="fw-semibold">A3 em nuvem</span> e desejo
                    utilizar!
                  </p>
                </button>
              </div>
              <div class="option">
                <button
                  ref="btnTokenA3"
                  class="btn option_button d-flex flex-column justify-content-center align-items-center"
                  type="button"
                  aria-label="Emitir certificado usando token ou cartão"
                  @click="!isMobile ? handleNavigate('tokenA3') : undefined"
                >
                  <img
                    class="option_image"
                    src="@/assets/images/CertificadoToken.svg"
                    alt="icon-shield"
                  />
                  <p class="text-start text-lg-center option_text">
                    Tenho um <span class="fw-semibold">token</span> ou
                    <span class="fw-semibold">cartão</span> e desejo utilizar!
                  </p>
                </button>
              </div>
            </div>

            <div class="contact-wrapper">
              <contact></contact>
            </div>
          </div>
        </div>
      </section>
    </div>
    <ModalValidationBirdVue
      @loading-start="
        () => {
          isLoadingHome = true
        }
      "
      @loading-end="
        () => {
          isLoadingHome = false
        }
      "
    ></ModalValidationBirdVue>
    <ModalSentDesktopVue></ModalSentDesktopVue>
  </div>
  <div class="cookies-alert" :class="[showCookiesAlert ? 'd-block' : 'd-none']">
    <div class="alert alert--notification" role="alert">
      <div class="alert__content">
        <h4 class="alert-heading">Cookies</h4>
        <div>
          Utilizamos os cookies para melhorar sua experiência.
          <span class="ms-1"
            >Para cumprir com a nova diretiva de privacidade, nós precisamos
            pedir seu</span
          >
          consentimento para definir os cookies. Confira nossa
          <a
            class="color--light ms-1 text-decoration-underline"
            href="/PoliticadeCookies.pdf"
            target="_blank"
          >
            política de cookies. Saiba mais!
          </a>
        </div>
        <button
          class="btn btn-light btn-sm mt-2"
          type="button"
          @click="closeAlert"
        >
          Fechar
        </button>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
  import {
    defineComponent,
    ref,
    computed,
    onMounted,
    onBeforeUnmount,
    nextTick,
    watch,
  } from 'vue'
  import { useRouter, useRoute } from 'vue-router'
  import { useDebounceFn } from '@vueuse/core'
  import { Modal } from 'bootstrap'
  import Icon from '@/components/Atoms/Icon.vue'
  import Contact from '@/components/Molecules/Contact.vue'
  import ModalValidationBirdVue from '@/components/templates/ModalValidationBird.vue'
  import ModalSentDesktopVue from '@/components/templates/ModalSentDesktop.vue'
  import allValidates from '@/utils/validates'
  import { useSolicitation } from '@/store/Pinia/useSolicitation.store'
  import { useAR } from '@/store/Pinia/useAR.store'
  import {
    useDynamicForms,
    STATE_DEFAULT,
  } from '@/store/Pinia/useDynamicForms.store'
  import browserDeviceCheck from '@/utils/browserDeviceCheck'
  import { useHubAuthPopup } from '@/composables/useHubAuthPopup'
  import arController from '@/infra/BirdId/controllers/ar.controller'
  import loginController, {
    ResponseLoginVoucher,
  } from '@/infra/BirdId/controllers/login.controller'
  import { useMainStore } from '@/store/Pinia/useMain.store'
  import saveDataVoucher from '@/utils/saveDataVoucher'
  import { useRouteBirdId } from '@/store/Pinia/useRouteBirdId.store'
  import { useDomainValidation } from '@/store/Pinia/useDomainValidation.store'
  import { useModalLoading } from '@/store/Pinia/useModalLoading.store'
  import { useToastGlobal } from '@/store/Pinia/useToastGlobal.store'
  import { AxiosError } from 'axios'
  import { useOeRecaptcha } from '@/composables/useOeRecaptcha'
  import config from '../../config'

  type ParamsToLoginVar = {
    iv: string
    token: string
    order: string
    cnpj: string
    transaction: string
    idperfiliti?: string
    idproduto?: string
  }

  export default defineComponent({
    name: 'HomeView',
    components: {
      Icon,
      Contact,
      ModalValidationBirdVue,
      ModalSentDesktopVue,
    },
    async beforeRouteEnter(to, from, next) {
      const main = useMainStore()
      const routeBird = useRouteBirdId()
      const arStore = useAR()
      const solicitation = useSolicitation()
      const validationDomain = useDomainValidation()
      const useLoading = useModalLoading()
      const useToast = useToastGlobal()
      const dynamicForms = useDynamicForms()

      const iv = to.query['access_token[iv]'] as string
      const token = to.query['access_token[encrypted_token]']
      const { order, cnpj, transaction, idperfiliti, idproduto } = to.query

      const queryParams = {
        iv,
        token,
        order,
        cnpj,
        transaction,
        idperfiliti:
          typeof idperfiliti === 'string' ? idperfiliti.trim() : undefined,
        idproduto: typeof idproduto === 'string' ? idproduto.trim() : undefined,
      } as ParamsToLoginVar

      const arSubDomain = to.params.arsubdomain || arStore.arData.subdomain
      const AR_SUBDOMAIN_NOT_FOUND = 'AR_SUBDOMAIN_NOT_FOUND'

      const getArData = async (arname: string) => {
        try {
          const { data: dataAr } = await arController.getArData(arname)

          return dataAr
        } catch (_error) {
          localStorage.setItem('ar-subdomain-error', to.fullPath || '')
          throw new Error(AR_SUBDOMAIN_NOT_FOUND)
        }
      }

      try {
        useLoading.setIsLoading({
          isLoading: true,
          title: 'Carregando...',
          image: 'clock',
        })

        main.clearData()
        routeBird.clearRoutes()
        solicitation.clearData()
        dynamicForms.clearData()

        const dataAr = await getArData(`${arSubDomain}`)
        const sub = (to.query.sub || '') as string
        arStore.setSub(sub)

        const modalSave = { ...dataAr, subdomain: arSubDomain, sub }

        arStore.setArData(modalSave)

        if (queryParams.iv && queryParams.token && queryParams.order) {
          if (Array.isArray(idproduto) || Array.isArray(idperfiliti)) {
            throw new Error(
              'Parâmetros idproduto e idperfiliti devem ser únicos',
            )
          }

          if (!queryParams.idproduto && !queryParams.idperfiliti) {
            throw new Error('Produto não informado corretamente.')
          }

          const { data } = await loginController.loginWithToken(
            queryParams.iv,
            queryParams.token,
            queryParams.order,
            to.params.arsubdomain as string,
            queryParams.cnpj || '',
            queryParams.idperfiliti,
            queryParams.idproduto,
          )

          if (queryParams.cnpj) {
            dynamicForms.setCNPJ(queryParams.cnpj)
          }

          solicitation.setIsRFB(data.isRFB)

          // create-with-token substitui o just-auth/login; sem isso o cessToken
          // fica vazio e chamadas autenticadas (ex.: check-email-ownership) falham
          // com "Sessão é obrigatória".
          solicitation.setCessToken({
            sessionData: data.sessionData,
            sessionId: data.sessionId,
          })

          const model = {
            ...data,
            voucher: to.query.order || '',
          }

          saveDataVoucher(model as ResponseLoginVoucher)
          routeBird.setRouterDone('voucher')

          return next({ name: 'Dados do Certificado Digital' })
        }

        if (
          // eslint-disable-next-line operator-linebreak
          to.query.route === 'check-domain-validation' &&
          // eslint-disable-next-line operator-linebreak
          to.query.user !== '' &&
          to.query.choosemethod !== ''
        ) {
          validationDomain.setType(to.query.choosemethod as string)
          solicitation.setUserName(`${to.query.user}` || '')
          return next({ path: `/domain-validation/${to.query.route}` })
        }

        return next()
      } catch (_error) {
        if (
          _error instanceof Error &&
          _error.message === AR_SUBDOMAIN_NOT_FOUND
        ) {
          return next({ name: 'WithoutRoute' })
        }

        const axiosError = _error as AxiosError
        const errorData = axiosError.response?.data as
          | { message: string }
          | undefined

        if (transaction && transaction !== '') {
          window.location.href = `${
            config.app.vlineUrl
          }${transaction}?message=${errorData?.message || axiosError.message}`
          return next()
        }

        useToast.toggleToastGlobal({
          isShow: true,
          message: `Erro de navegação. Motivo: ${
            errorData?.message || axiosError.message
          }`,
        })
        return next()
      } finally {
        setTimeout(() => {
          useLoading.setIsLoading({ isLoading: false })
        }, 1500)
      }
    },
    setup() {
      // Router
      const router = useRouter()
      const route = useRoute()

      // Stores
      const mainStore = useMainStore()
      const dynamicFormsStore = useDynamicForms()
      const solicitationStore = useSolicitation()
      const modalLoadingStore = useModalLoading()

      // Refs
      const btnTokenA3 = ref<HTMLButtonElement | null>(null)
      const easterEggImg = ref<HTMLImageElement | null>(null)
      const modalBirdInstance = ref<InstanceType<typeof Modal> | null>(null)
      const isLoadingHome = ref(false)
      const isMobile = ref(false)
      const showCookiesAlert = ref(true)
      const clickCount = ref(0)
      const isAnimating = ref(false)
      const model = ref({
        cpf: '',
        otp: '',
        termos: false,
      })

      // Setup
      const oeRecaptcha = useOeRecaptcha()

      // Computed
      const cookies = computed(() => mainStore.cookies)

      // Methods
      const handleNavigate = (routeName: string) => {
        router.push(`/${routeName}`)
      }

      const queryToStorage = () => {
        const oldLogin = { cpf: '', unidade: '', voucher: '' }

        oldLogin.cpf = route.query.username?.toString() || ''
        oldLogin.unidade = route.query.unidade?.toString() || ''
        oldLogin.voucher = route.query.voucher?.toString() || ''

        if (route.query.voucher !== '') {
          localStorage.setItem('voucher', JSON.stringify(oldLogin.voucher))
        }

        if (allValidates.validateCPF(route.query.username?.toString() || '')) {
          model.value.cpf = route.query.username?.toString() || ''
        }

        const preFilled = {
          ...STATE_DEFAULT,
          tel: route.query.telefone?.toString() || '',
          cpf: '',
          email: route.query.email?.toString() || '',
          cnpj: route.query.cnpj?.toString() || '',
          razaoSocial: route.query.razaoSocial?.toString() || '',
          uf: route.query.uf?.toString() || '',
          municipio: route.query.municipio?.toString() || '',
        }

        dynamicFormsStore.setFormData(preFilled)
        solicitationStore.setNegociationId(route.query.token?.toString() || '')
        mainStore.setUnidade(route.query.unidade?.toString() || '')
      }

      const handleActionButton = () => {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const btn: any = btnTokenA3.value
        if (isMobile.value) {
          btn.setAttribute('data-bs-toggle', 'modal')
          btn.setAttribute('data-bs-target', '#modalSentDesktop')
        } else {
          btn.removeAttribute('click')
        }
      }

      const closeAlert = () => {
        showCookiesAlert.value = false
        localStorage.setItem('cookies', JSON.stringify(false))
      }

      const handleBirdIdButtonClick = () => {
        mainStore.clearBirdSessionToken()
        oeRecaptcha.showBadge()
        setTimeout(() => {
          if (modalBirdInstance.value) {
            modalBirdInstance.value.show()
          }
        }, 500)
      }

      const handleHubCloudButtonClick = useDebounceFn(async () => {
        mainStore.clearBirdSessionToken()
        await hubAuthPopup.openPopup()
      }, 300)

      const EASTER_EGG_CLICK_THRESHOLD = 7
      const EASTER_EGG_ANIMATION_DURATION = 1200
      const EASTER_EGG_RESET_TIMEOUT = 3000

      const hubAuthPopup = useHubAuthPopup({
        onSuccess: () => {
          isAnimating.value = false
          clickCount.value = 0

          if (modalBirdInstance.value) {
            modalBirdInstance.value.show()
          }
        },
        onPopupClosed: () => {
          isAnimating.value = false
          clickCount.value = 0
        },
        onError: () => {
          isAnimating.value = false
          clickCount.value = 0
        },
      })

      let resetTimer: ReturnType<typeof setTimeout> | null = null

      const handleEasterEggClick = async () => {
        if (
          isAnimating.value ||
          hubAuthPopup.isLoading.value ||
          hubAuthPopup.isPopupOpen.value
        ) {
          return
        }

        if (resetTimer) {
          clearTimeout(resetTimer)
        }

        clickCount.value++

        if (clickCount.value > EASTER_EGG_CLICK_THRESHOLD) {
          clickCount.value = 0
          return
        }

        if (clickCount.value === EASTER_EGG_CLICK_THRESHOLD) {
          isAnimating.value = true
          setTimeout(() => {
            const modalVersionEl = document.getElementById('modal-version')
            if (modalVersionEl) {
              new Modal(modalVersionEl).show()
            }
            isAnimating.value = false
            clickCount.value = 0
          }, EASTER_EGG_ANIMATION_DURATION)
          return
        }

        resetTimer = setTimeout(() => {
          clickCount.value = 0
        }, EASTER_EGG_RESET_TIMEOUT)
      }

      onBeforeUnmount(() => {
        if (resetTimer) {
          clearTimeout(resetTimer)
          resetTimer = null
        }
      })

      // Lifecycle
      onMounted(async () => {
        queryToStorage()
        isMobile.value = browserDeviceCheck()
        showCookiesAlert.value = cookies.value
        handleActionButton()

        // Aguarda o próximo tick para garantir que o store está hidratado
        await nextTick()

        // Inicializa a instância da modal
        const modalElement = document.getElementById('modalValidationBird')
        if (modalElement) {
          modalBirdInstance.value = new Modal(modalElement, {
            backdrop: 'static',
            keyboard: false,
          })
        }
      })

      // Abre modal automaticamente após loading, se houver token válido do Hub
      // Previne race condition entre carregamento da página e recebimento do token via postMessage
      watch(
        () => modalLoadingStore.modalLoading.isLoading,
        (isLoading) => {
          if (
            !isLoading &&
            mainStore.getValidBirdSessionToken &&
            modalBirdInstance.value
          ) {
            modalBirdInstance.value.show()
          }
        },
      )

      return {
        btnTokenA3,
        easterEggImg,
        isLoadingHome,
        isMobile,
        showCookiesAlert,
        isAnimating,
        model,
        cookies,
        handleNavigate,
        queryToStorage,
        handleActionButton,
        closeAlert,
        handleEasterEggClick,
        handleBirdIdButtonClick,
        handleHubCloudButtonClick,
      }
    },
  })
</script>

<style scoped lang="stylus">
    .home
      height: 100%
      width: 100%
      color: #2F3242
      padding: 0 32px
      margin: 40px auto 0 auto

      .container
        background-image: url('@/assets/images/background-home.png')
        background-position-y: 20px
        background-size: 40%
        background-repeat: no-repeat

      .option
        flex: 1
        display: flex
        flex-direction: column

      .option_button
        min-width: 217px
        flex: 1
        margin: 0
        padding: 12px 16px
        justify-content: flex-start !important

        border: 1px solid #E6E7EC
        background-color: #FFF
        border-radius: 10px
        transition: 0.35s

        &:hover
          border-color: rgba(16, 114, 102, 0.2)

        &:focus-visible
          outline: 2px solid #19665B
          outline-offset: 2px

        .option_image
          width: auto
          height: 35px

        .option_text
          width: 100%
          padding: 8px 0 0 0
          font-size: 1rem
          font-weight: 400
          color: #19665B

    .cookies-alert
      position: absolute
      bottom: 156px
      right: 10px
      left: 10px
      width: 100%
      max-width: 370px
      height: 278px;
      padding: 1rem
      text-align: left
      font-size: 1.2rem
      z-index: 9999
      margin: 0 auto

    @media screen and (max-width: 992px)
      .home
        background-size: 100%
        background-position-y: -160px
        background-repeat: no-repeat
        .container
          background-image: none
        .option
          flex: none
          width: 100%
          display: flex
          flex-direction: column
          border: none
        .option_button
          height: auto
          flex: none
          min-height: unset
          padding: 16px
          justify-content: flex-start !important
          flex-direction: row !important
          gap: 16px
          .option_image
            height: 48px
            width: auto
          .option_text
            text-align: left
            padding: 0
        .contact-wrapper
          margin-bottom: 60px

      .cookies-alert
        bottom: 20px
        font-size: 1rem

    @media screen and (max-width: 576px)
      .home
        background-position-y: -80px

    @media screen and (max-width: 1400px)
      .option_text
        font-size: 0.9rem

    .easter-egg-img
      cursor: default
      transition: transform 0.2s
      height: 112px
      width: fit-content

    .easter-egg-animate
      animation: easterEggJump 1.2s ease-in-out

    @keyframes easterEggJump
      0%, 100%
        transform: translateY(0) rotate(0deg)
      15%
        transform: translateY(-30px) rotate(0deg)
      30%
        transform: translateY(0) rotate(0deg)
      45%
        transform: translateY(-30px) rotate(0deg)
      60%
        transform: translateY(0) rotate(180deg)
      100%
        transform: translateY(0) rotate(360deg)

  .contact-wrapper
    width: 683px
    padding: 0
    display: flex
    flex-direction: row
    align-items: center
    justify-content: center
</style>
